import React from 'react';
import { Accordion } from '../elements';

export function FaqItem(props: { question: string; index: string; children: React.ReactNode }) {
    return (
        <div className="pl25 pr25">
            <Accordion index={props.index} title={props.question}>
                {props.children}
            </Accordion>
        </div>
    );
}
